import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { PlatformChartType } from '@data/_generated-api/platform-api/models/platform-chart-type';
import { HdContentLanguageService } from '../bodygraph/hd-content-language.service';
import { HD_CHART_TYPE_COLORS, HD_CHART_TYPE_ICONS } from './hd-chart-type-metadata';

/** Chart-type als badge met icoon + vertaald label (`enums.chartType.*`). */
@Component({
  selector: 'hd-chart-type-tag',
  standalone: true,
  imports: [SharedModule],
  template: `<e-badge [color]="color()" small [prependIcon]="icon()">{{ label() }}</e-badge>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdChartTypeTagComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly contentLang = inject(HdContentLanguageService);

  readonly type = input<PlatformChartType | null | undefined>(undefined);

  private readonly effectiveType = computed(() => this.type() ?? PlatformChartType.Unknown);
  protected readonly icon = computed(() => HD_CHART_TYPE_ICONS[this.effectiveType()]);
  protected readonly color = computed(() => HD_CHART_TYPE_COLORS[this.effectiveType()]);
  protected readonly label = computed(() => {
    this.contentLang.translationsLoadedTick();
    const language = this.contentLang.effectiveLang();
    return this.transloco.translate<string>(`enums.chartType.${this.effectiveType()}`, undefined, language);
  });
}
